import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

interface OrganizationSeoProps {
    title: string;
    description: string;
    url: string;
    image?: string;
}

const OrganizationSeo: React.FC<OrganizationSeoProps> = ({
                                                             title,
                                                             description,
                                                             url,
                                                             image,
                                                         }) => {
    const { i18n } = useTranslation();
    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "@id": "https://go-te.co/#organization",
        "name": "Goteco",
        "alternateName": "GoTeCo",
        "url": "https://go-te.co/",
        "logo": "https://go-te.co/logo.svg",
        "description": "Goteco is a leading provider of technological solutions, delivering innovative and reliable software for various industries. Our experienced team develops and manages complex IT projects, ensuring high quality and customer satisfaction.",
        "slogan": "Your trusted IT partner for your success",
        "foundingDate": "2013-01-03",
        "email": "info@go-te.co",
        "telephone": ["+380443339274", "+15854451323"],
        "address": {
            "@type": "PostalAddress",
            "streetAddress": "Svitlytskoho St, 35",
            "addressLocality": "Kyiv",
            "postalCode": "04123",
            "addressCountry": "UA"
        },
        "areaServed": [
            { "@type": "Country", "name": "Ukraine" },
            { "@type": "Country", "name": "United States" }
        ],
        "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "email": "info@go-te.co",
            "telephone": "+380443339274"
        },
        "sameAs": ["https://www.linkedin.com/company/gote-co/"]
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(jsonLd)}
            </script>

            {/* OpenGraph */}
            <meta property="og:locale" content={i18n.language === "ua" ? "uk_UA" : "en_US"} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            {image && <meta property="og:image" content={image} />}
            <meta property="og:site_name" content="GoTeCo" />
        </Helmet>
    );
};

export default OrganizationSeo;
